export const getTagInfo = (target, tagList) => {
    if(!tagList){
        return null;
    }
    const filteredTags = tagList.filter((tag)=> tag && tag.contentType === target)
    if(filteredTags){
        return filteredTags[0];
    }

    return null;
}